let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gBME1")).then(() => parcelRequire('dHZrs'));